import { caloTheme } from 'src/theme/calo';

import { Box } from '@mui/material';

interface NextPaymentProgressProps {
  children: React.ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  sx?: any;
}

export const NextPaymentProgress = ({ children, onMouseEnter, onMouseLeave, sx, ...props }: NextPaymentProgressProps) => (
  <Box
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      justifyContent: 'center',
      [caloTheme.breakpoints.up('md')]: {
        marginLeft: 'auto',
        minHeight: '250px'
      },
      ...sx
    }}
    {...props}
  >
    {children}
  </Box>
);
